/* eslint-disable no-useless-escape */
import { head, isArray, isEmpty, last } from "lodash";
import { ApiResponse, fetchApi } from "./api";
import { Coordinates } from "./useMapCenter";

export const getUnshortenedGmapsUrl = async (value: string) => {
  const GMAPS_SHORT_URL =
    /https:\/\/(goo\.gl\/maps|g\.page|maps\.app\.goo\.gl)\/[^ ]*/;
  const matchedGmapsShortUrl = GMAPS_SHORT_URL.exec(value);
  const url = isEmpty(matchedGmapsShortUrl) ? null : head(matchedGmapsShortUrl);

  if (!url) return;

  try {
    const response = await fetchApi("/api/gmap-unshort", {
      method: "POST",
      body: JSON.stringify({ url })
    });

    const apiResponse: ApiResponse<{ url: string[] }> = await response.json();

    return isArray(apiResponse.data.url)
      ? last(apiResponse.data.url)
      : apiResponse.data.url;
  } catch {
    return;
  }
};

const getCoordinates = async (
  value: string
): Promise<Coordinates | undefined> => {
  let matchedLatLngValues: RegExpExecArray | string[] | null =
    LAT_LNG_REGEX.exec(value.replace(" ", ""));

  if (!matchedLatLngValues) {
    matchedLatLngValues = URL_COORDINATES_REGEX.exec(value);
  }

  if (isArray(matchedLatLngValues) && matchedLatLngValues.length >= 3) {
    const [, lat, lng] = matchedLatLngValues;

    if (!lat || !lng) return;

    return [parseFloat(lng), parseFloat(lat)];
  }
};

export default getCoordinates;

//
// Utils
//

const URL_COORDINATES_REGEX = /!3d(-?\d+(?:\.\d+)?)!4d(-?\d+(?:\.\d+))/;
const LAT_LNG_REGEX =
  /(^[-+]?(?:[1-8]?\d(?:\.\d+)?|90(?:\.0+)?)),\s*([-+]?(?:180(?:\.0+)?|(?:(?:1[0-7]\d)|(?:[1-9]?\d))(?:\.\d+)?))$/;
